import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { CurrencyInput } from '@/components/ui/currency-input';
import { SubmitDealStepProps } from '@/types/submit-deal.types';

export const StepAddbacks = ({ formData, updateFormData, errors, clearError, t }: SubmitDealStepProps) => {
  const handleChange = (field: string, value: string | number) => {
    updateFormData('addbacks', { [field]: value });
    clearError(field);
  };

  const handleNumericChange = (field: string, rawValue: string) => {
    const value = rawValue === '' ? '' : parseInt(rawValue);
    updateFormData('addbacks', { [field]: value });
    clearError(field);
  };

  const totalAddbacks = 
    (Number(formData.addbacks.ownerSalary) || 0) +
    (Number(formData.addbacks.autoExpense) || 0) +
    (Number(formData.addbacks.travelEntertainment) || 0) +
    (Number(formData.addbacks.nonRecurringLegal) || 0) +
    (Number(formData.addbacks.otherDiscretionary) || 0);

  return (
    <div className="space-y-6">
      <div className="bg-muted/50 p-4 rounded-lg">
        <p className="text-sm text-muted-foreground">{t.step7.sectionHint}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="ownerSalary">{t.step7.ownerSalary}</Label>
          <CurrencyInput id="ownerSalary" min={0} value={formData.addbacks.ownerSalary || ''} onChange={(v) => handleNumericChange('ownerSalary', v)} />
        </div>

        <div className="space-y-2">
          <Label htmlFor="autoExpense">{t.step7.autoExpense}</Label>
          <CurrencyInput id="autoExpense" min={0} value={formData.addbacks.autoExpense || ''} onChange={(v) => handleNumericChange('autoExpense', v)} />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="travelEntertainment">{t.step7.travelEntertainment}</Label>
          <CurrencyInput id="travelEntertainment" min={0} value={formData.addbacks.travelEntertainment || ''} onChange={(v) => handleNumericChange('travelEntertainment', v)} />
        </div>

        <div className="space-y-2">
          <Label htmlFor="nonRecurringLegal">{t.step7.nonRecurringLegal}</Label>
          <CurrencyInput id="nonRecurringLegal" min={0} value={formData.addbacks.nonRecurringLegal || ''} onChange={(v) => handleNumericChange('nonRecurringLegal', v)} />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="otherDiscretionary">{t.step7.otherDiscretionary}</Label>
        <CurrencyInput id="otherDiscretionary" min={0} value={formData.addbacks.otherDiscretionary || ''} onChange={(v) => handleNumericChange('otherDiscretionary', v)} />
      </div>

      <div className="bg-primary/10 p-4 rounded-lg">
        <div className="flex justify-between items-center">
          <span className="font-medium">Total Add-Backs:</span>
          <span className="text-xl font-bold">${totalAddbacks.toLocaleString('en-US')}</span>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="addbackRationale">{t.step7.addbackRationale}</Label>
        <Textarea
          id="addbackRationale"
          value={formData.addbacks.addbackRationale}
          onChange={(e) => handleChange('addbackRationale', e.target.value)}
          placeholder={t.step7.addbackRationalePlaceholder}
          rows={4}
        />
      </div>
    </div>
  );
};
